import styled from '@emotion/styled'

import type { FC } from 'react'

import Highlighter from '@segment/matcha/components/Highlighter'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import AccordionBase, * as Accordion from '@segment/matcha/recipes/Accordion'

import { useActiveState } from '@segment/utils/useActiveState'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import type { TemplateProps } from './data/TemplateProps'

interface TemplateAccordionsProps {
  data: TemplateProps[]
}

const TemplateAccordions: FC<TemplateAccordionsProps> = ({ data }) => {
  const pageConfig = usePageConfig()
  const items = new Array(data.length).fill(false)
  const { activeItems, toggle } = useActiveState(items, {
    allowMultipleActive: true,
  })
  return (
    <Wrapper>
      {activeItems.map((active, index) => (
        <AccordionBase key={`item-${index}`}>
          <Accordion.Header onClick={() => toggle(index)}>
            <Accordion.TitleWrapper>
              <Accordion.Title opened={active} aria-label="Company Logo">
                {data[index].logo}
              </Accordion.Title>
              <Accordion.SubTitle>{data[index].description}</Accordion.SubTitle>
            </Accordion.TitleWrapper>
            <Accordion.Icon opened={active} />
          </Accordion.Header>
          <Accordion.Body>
            {active && (
              <Accordion.ContentWrapper>
                <Highlighter content={data[index].syntax} />
                <StyledButtonText tag="a" href={getAbsoluteUrl(`/demo/`, pageConfig)} iconEnd={ChevronRightIcon}>
                  Get a demo
                </StyledButtonText>
              </Accordion.ContentWrapper>
            )}
          </Accordion.Body>
        </AccordionBase>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0px, 1280px);
  grid-template-areas: 'contents';
  overflow-y: hidden;
  max-width: 844px;
  margin: 0 auto;
`

const StyledButtonText = styled(ButtonText)`
  margin-top: 32px;
`

export default TemplateAccordions
